export const MAX_TIME_FOR_EDITING_OR_DELETING_REPORT_MESSAGE = 30; // in minutes
